import React from "react";

function AppButton({ text, onClick }) {
  return (
    <button
      className="
      bg-mix-400
      font-bold
      rounded-full
      px-6
      py-3
      md:px-8
      lg:px-8
      text-white
      shadow-md
      uppercase
      hover:shadow-lg
      hover:bg-transparent
      hover:text-mix-400
      hover:text-semibold
      transition
      ease-out
      duration-400
      border-2
      border-mix-400
    "
      onClick={onClick}
    >
      {text}
    </button>
  );
}

export default AppButton;
